<label class="hc-toggle" [class.hc-toggle--checked]="checked"
       [class.hc-toggle--disabled]="disabled">
  <span class="hc-toggle__track" role="switch"
        [attr.aria-checked]="checked"
        [attr.aria-disabled]="disabled || null"
        tabindex="0"
        (click)="toggle()"
        (keydown.space)="$event.preventDefault(); toggle()"
        (keydown.enter)="toggle()">
    <span class="hc-toggle__thumb"></span>
  </span>
  @if (label) {
    <span class="hc-toggle__label">{{ label }}</span>
  }
  <ng-content></ng-content>
</label>
